import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import useIsFieldRequired from '../../../utility/useIsFieldRequired';

const RMSTimePicker = ({ name, label, disabled = false, ampm = true, size = 'small', ...rest }) => {
  const { control, trigger } = useFormContext();
  const isRequired = useIsFieldRequired(name);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field, fieldState: { error } }) => (
          <KeyboardTimePicker
            {...rest}
            autoOk
            fullWidth
            variant="inline"
            inputVariant="outlined"
            size={size}
            label={label}
            disabled={disabled}
            ampm={ampm}
            value={field.value || null}
            onChange={(time) => {
              field.onChange(time);
              trigger(name);
            }}
            onBlur={field.onBlur}
            error={!!error}
            helperText={error?.message}
            required={isRequired}
          />
        )}
      />
    </MuiPickersUtilsProvider>
  );
};

export default RMSTimePicker;
